module.exports = __webpack_public_path__ + "img/plus.63e02003.svg";